import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => {
    return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    const [notificationsFetch, setNotificationsFetch] = useState(true);
    const [notificationsCount, setNotificationsCount] = useState(0);

    const setNotificationsExternal = (newNotifications) => {
        setNotifications(newNotifications);
    };

    return (
        <NotificationContext.Provider value={{ notifications, setNotifications: setNotificationsExternal, notificationsFetch, setNotificationsFetch, notificationsCount, setNotificationsCount }}>
            {children}
        </NotificationContext.Provider>
    );
};
